export enum URLS {
  BOARD = "/",

  MRI = "/mri",
  MRI_POLICES = "/mri/polices",
  MRI_POLICE_DETAILS = "/mri/polices/:id",
  MRI_DEVIS = "/mri/devis",

  PNO = "/pno",
  PNO_CONTRACTS = "/pno/polices",
  PNO_SOUSCRIPTION = "/pno/nouvellePolice",
  PNO_SOUSCRIPTION_REPRISE = "/pno/souscription/:id",
  PNO_SOUSCRIPTIONS_EN_COURS = "/pno/souscriptionsEnCours",
  PNO_SINISTRES = "/pno/sinistres",
  PNO_QUITTANCES = "/pno/quittances",

  MRH = "/mrh/polices",
  PJ = "/pj/polices",
  DO = "/do/polices",

  PAIEMENT_PLANIFIES = "/termpolicies",

  SINISTRES = "/sinistres",
  CONTRATS = "/contrats",
  FORBIDDEN = "/forbiddenAccess",
}

export type TypeURL = URLS;
